<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                    <v-container>
                        <v-row class="mt-5">
                            <v-col cols="8" md="2" class="mt-n4 d-flex">
                                <v-icon class="mt-n4">event</v-icon>
                                <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class='casilla_beige text-body-2' v-model="fecha_orden" label="Fecha" readonly v-bind="attrs" v-on="on" dense rounded></v-text-field>
                                    </template>
                                    <v-date-picker v-model="fecha_orden" @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="10" md="5" class="mt-n4">
                                <v-alert class='text-caption' dense shaped text type="info">
                                    Fecha Orden de Compra !!!
                                </v-alert>
                            </v-col>
                            <v-col cols="8" md="3" class="mt-n5 text-end">
                                <v-text-field label="N° Orden" class='casilla_grey text-body-2' style="width: 200px;float:right" v-model="orden" dense rounded disabled></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="mt-n4 text-end">
                                <strong class="mt-n5">Editar Orden</strong>
                                <v-btn @click="d_orden=true" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-row>
            <v-row class="mt-2">
                <v-col cols="12" md="7">
                    <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                        <v-container>
                            <v-row class="mt-5">
                                <v-col cols="12" md="4" class="mt-n5 d-flex">
                                    <h5 class="mt-1">Proveedor</h5>
                                    <v-btn @click="lista_proveedor()" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                    <v-btn @click="editar_proveedor()" class="mt-n1 ml-5" x-small color="cyan" dark rounded fab><v-icon small>edit</v-icon></v-btn>
                                </v-col>
                                <v-col cols="12" md="3" class="mt-n5">
                                    <v-text-field v-if="btn_proveedor!=true" placeholder="Rut" class='casilla_grey text-body-2' v-model="rut" dense rounded readonly></v-text-field>
                                    <v-text-field v-else maxlength="10" placeholder="Rut" class='casilla_beige text-body-2' v-model="rut" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="5" class="mt-n5">
                                    <v-text-field v-if="btn_proveedor!=true" placeholder="Razon Social" class='casilla_grey text-body-2' v-model="razon" dense rounded readonly></v-text-field>
                                    <v-text-field v-else placeholder="Razon Social" class='casilla_beige text-body-2' v-model="razon" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="7" class="mt-n5">
                                    <v-text-field v-if="btn_proveedor!=true" placeholder="Giro" class='casilla_grey text-body-2' v-model="giro" dense rounded readonly></v-text-field>
                                    <v-text-field v-else placeholder="Giro" class='casilla_beige text-body-2' v-model="giro" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="5" class="mt-n5">
                                    <v-text-field v-if="btn_proveedor!=true" placeholder="Contacto" class='casilla_grey text-body-2' v-model="contacto" dense rounded readonly></v-text-field>
                                    <v-text-field v-else placeholder="Contacto" class='casilla_beige text-body-2' v-model="contacto" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="5" class="mt-n5">
                                    <v-text-field v-if="btn_proveedor!=true" placeholder="Telefono" class='casilla_grey text-body-2' v-model="telefono" dense rounded readonly></v-text-field>
                                    <v-text-field v-else placeholder="Telefono" class='casilla_beige text-body-2' v-model="telefono" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="7" class="mt-n5">
                                    <v-text-field v-if="btn_proveedor!=true" placeholder="Email" class='casilla_grey text-body-2' v-model="email" dense rounded readonly></v-text-field>
                                    <v-text-field v-else placeholder="Email" class='casilla_beige text-body-2' v-model="email" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="7" class="mt-n5">
                                    <v-text-field v-if="btn_proveedor!=true" placeholder="Direccion" class='casilla_grey text-body-2' v-model="direccion" dense rounded readonly></v-text-field>
                                    <v-text-field v-else placeholder="Direccion" class='casilla_beige text-body-2' v-model="direccion" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="12" md="5" class="mt-n5">
                                    <v-text-field v-if="btn_proveedor!=true" placeholder="Comuna - Ciudad" class='casilla_grey text-body-2' v-model="comuna_ciudad" dense rounded readonly></v-text-field>
                                    <v-text-field v-else placeholder="Comuna - Ciudad" class='casilla_beige text-body-2' v-model="comuna_ciudad" dense rounded></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-sheet>
                </v-col>
                <v-col cols="12" md="5">
                    <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                        <v-container>
                            <v-row class="mt-5">
                                <v-col cols="5" md="3" class="mt-n5 text-end">
                                    <h5 class="mt-2">Autorizado por: </h5>
                                </v-col>
                                <v-col cols="12" md="8" class="mt-n5 d-flex">
                                    <v-text-field class='casilla_beige text-body-2 ml-2' v-model="autorizado" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="4" md="3" class="mt-n5 text-end">
                                    <h5 class="mt-2">Transporte: </h5>
                                </v-col>
                                <v-col cols="12" md="8" class="mt-n5">
                                    <v-text-field class='casilla_beige text-body-2 ml-2' v-model="transporte" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="4" md="3" class="mt-n5 text-end">
                                    <h5 class="mt-2">Atención de: </h5>
                                </v-col>
                                <v-col cols="12" md="8" class="mt-n5">
                                    <v-text-field class='casilla_beige text-body-2 ml-2' v-model="atencion" dense rounded></v-text-field>
                                </v-col>
                                <v-col cols="5" md="4" class="mt-n5 text-end">
                                    <h5 class="mt-2">Fecha de Entrega: </h5>
                                </v-col>
                                <v-col cols="8" md="5" class="mt-n5 d-flex">
                                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field class='casilla_beige ml-2 text-body-2' v-model="fecha_entrega" readonly v-bind="attrs" v-on="on" dense rounded></v-text-field>
                                        </template>
                                        <v-date-picker v-model="fecha_entrega" @input="menu2 = false"></v-date-picker>
                                    </v-menu>
                                    <v-icon class="mt-1">event</v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-sheet>
                </v-col>
            </v-row>
            <v-row class="mt-5">
                <v-col cols="10" md="2" class="mt-n5">
                    <v-text-field label="Codigo" class='casilla_beige text-body-2 ml-2' v-model="codigo" dense rounded></v-text-field>
                </v-col>
                <v-col cols="12" md="5" class="mt-n5">
                    <v-text-field label="Descripción" class='casilla_beige text-body-2 ml-2' v-model="descripcion" dense rounded></v-text-field>
                </v-col>
                <v-col cols="8" md="2" class="mt-n5">
                    <v-text-field @keypress="onlyDecimal" label="Precio" class='casilla_beige text-body-2 ml-2' v-model="precio" dense rounded></v-text-field>
                </v-col>
                <v-col cols="8" md="2" class="mt-n5">
                    <v-text-field @keypress="onlyDecimal" label="Cantidad" class='casilla_beige text-body-2 ml-2' v-model="cantidad" dense rounded></v-text-field>
                </v-col>
                <v-col cols="4" md="1" class="mt-n3 text-center">
                    <v-btn @click="add_item()" x-small color="indigo" rounded dark>Agregar Item</v-btn>
                </v-col>
            </v-row>
            <div class="mt-4 scroller">
                <v-sheet v-for="item in items" :key="item.id" class="mb-1" style="border:1px solid lightgray; background-color: #F5F5F5;" width="100%" rounded>
                    <v-container>
                        <v-row class="mt-2">
                            <v-col cols="3" md="1" class="mt-n5">
                                <h6 class="grey--text">Item</h6>
                                <h5>{{ item.id }}</h5>
                            </v-col>
                            <v-col cols="3" md="1" class="mt-n5">
                                <h6 class="grey--text">Codigo</h6>
                                <h5>{{ item.codigo }}</h5>
                            </v-col>
                            <v-col cols="12" md="6" class="mt-n5">
                                <h6 class="grey--text">Descripción</h6>
                                <h5>{{ item.descripcion }}</h5>
                            </v-col>
                            <v-col cols="4" md="1" class="mt-n5">
                                <h6 class="grey--text">Precio</h6>
                                <h5>${{new Intl.NumberFormat('de-DE').format(item.precio)}}</h5>
                            </v-col>
                            <v-col cols="3" md="1" class="mt-n5 text-center">
                                <h6 class="grey--text">Cantidad</h6>
                                <h5>{{new Intl.NumberFormat('de-DE').format(item.cantidad)}}</h5>
                            </v-col>
                            <v-col cols="4" md="1" class="mt-n5">
                                <h6 class="grey--text">total</h6>
                                <h5>{{new Intl.NumberFormat('de-DE').format(item.total)}}</h5>
                            </v-col>
                            <v-col cols="1" md="1" class="mt-n2 text-center">
                                <v-icon @click="delete_item(item)" color="error" small>delete</v-icon>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </div>
            <v-row class="mt-3">
                <v-col cols="12" md="3" class="mt-n3">
                    <v-select label="Forma de Pago" class='casilla_beige  text-body-2' v-model="forma" :items="formas" dense rounded></v-select>
                </v-col>
                <v-col cols="12" md="4" class="mt-n3">
                    <v-text-field label="Observación" class='casilla_beige text-body-2' v-model="observa" dense rounded></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="mt-n2">
                    <v-btn @click="clsInput()" color="teal" rounded dark small block>Limpiar</v-btn>
                </v-col>
                <v-col cols="12" md="2" class="mt-n2">
                    <div v-if="btn_editar!=true">
                        <v-btn v-if="btn_grabar!=true" @click="save_orden()" color="teal" rounded dark small block>Grabar</v-btn>
                        <v-btn v-else color="grey" rounded dark small block>Grabar</v-btn>
                    </div>
                    <div v-else>
                        <v-btn @click="update_orden()" v-if="btn_grabar!=true" color="teal" rounded dark small block>Actualizar</v-btn>
                        <v-btn v-else color="grey" rounded dark small block>Actualizar</v-btn>
                    </div>
                </v-col>
                <v-col cols="12" md="1" class="mt-n2 text-center">
                    <v-btn @click="print_orden()" small color="teal" outlined icon><v-icon small>print</v-icon></v-btn>
                </v-col>
            </v-row>
            <v-divider class="mt-5 mb-5"></v-divider>
        </v-container>

        <!-- lista de proveedores -->
        <v-dialog v-model="d_proveedor" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_proveedor=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Proveedores</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="proveedor_search" label="Buscar Proveedor" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProveedores" dense dark height="400px" fixed-header
                    :search="proveedor_search" :headers="proveedor_titulo" :items="proveedor_lista" 
                    :page.sync="proveedor_page" :items-per-page="proveedor_itemsPerPage"  
                    @page-count="proveedor_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                    <template v-slot:item.rut="{ item }">
                        <v-chip small>
                            {{ item.rut }}
                        </v-chip>
                    </template>
                </v-data-table>
                <v-pagination v-model="proveedor_page" :length="proveedor_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- lista de ordenes -->
        <v-dialog v-model="d_orden" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_orden=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Ordenes de Compra</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="orden_search" label="Buscar Orden" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleOrdenes" dense dark height="400px" fixed-header
                    :search="orden_search" :headers="orden_titulo" :items="orden_lista" 
                    :page.sync="orden_page" :items-per-page="orden_itemsPerPage"  
                    @page-count="orden_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                    <template v-slot:item.orden="{ item }">
                        <v-chip small>
                            {{ item.orden }}
                        </v-chip>
                    </template>
                    <template v-slot:item.total="{ item }">
                        {{new Intl.NumberFormat('de-DE').format(parseFloat(item.total).toFixed(0))}}
                    </template>
                </v-data-table>
                <v-pagination v-model="orden_page" :length="orden_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-dialog v-model="d_pdf" persistent>
            <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="close_pdf()" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
                </v-card-title>
                <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="600px" type="application/pdf"></iframe>
            </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
<!--
        <img id="logo" src="https://www.app.bodeganet.cl/Api_TerraFirma/public/Templates/logoTerra.jpg" height="0" width="0">
-->
        <img id="logo" src="@/assets/logoDosp.jpg" height="0" width="0">

    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 26px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightgray;
    color:black
}
.col-color-blue-grey >>> th {
    background-color: #c5e3e7;
}
.casilla_beige {
    background-color: beige; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_grey {
    background-color: lightgray ; 
    height: 30px;
    border: 1px solid lightgray;
}
.scroller {
  height: 13em;
  line-height: 1em;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  border: 1px solid lightgray;
}
</style>
<script>
import { jsPDF } from "jspdf";
import axios from "axios";
export default {
  name: 'Inventario',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,

    loading:false,

    snack:false,
    color_snack:'',
    mensaje:'',

    emisor:[],

    menu1:false,
    fecha_orden:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    orden:'',

    id_proveedor:0,
    rut:'',
    razon:'',
    giro:'',
    contacto:'',
    telefono:'',
    email:'',
    direccion:'',
    comuna_ciudad:'',

    autorizado:'',
    transporte:'',
    atencion:'',
    menu2:false,
    fecha_entrega:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

    codigo:'',
    descripcion:'',
    precio:'',
    cantidad:'',

    items:[],

    forma:'Contado',
    formas:['Contado', 'Transferencia', 'Cheque' ],
    observa:'',

    btn_grabar:false,
    btn_editar:false,
    btn_proveedor:false,

    bloqueo:null,

    d_proveedor:false,
    proveedor_titulo: [
      { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
      { text: 'Razon Social', align: 'start', sortable: true, value: 'razon' },
      { text: 'Contacto', align: 'start', sortable: true, value: 'contacto' },
      { text: 'Telefono', align: 'start', sortable: true, value: 'telefono' },
      { text: 'Email', align: 'start', sortable: true, value: 'email' },
    ],
    proveedor_lista: [],
    proveedor_page: 1,
    proveedor_pageCount: 0,
    proveedor_itemsPerPage: 1000000,
    proveedor_search:'', 

    d_orden:false,
    orden_titulo: [
      { text: 'Orden', align: 'start', sortable: true, value: 'orden' },
      { text: 'Fecha', align: 'start', sortable: true, value: 'fecha' },
      { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
      { text: 'Razon Social', align: 'start', sortable: true, value: 'razon' },
      { text: 'Total', align: 'center', sortable: true, value: 'total' },
    ],
    orden_lista: [],
    orden_page: 1,
    orden_pageCount: 0,
    orden_itemsPerPage: 1000000,
    orden_search:'', 
    
    descuento:0,
    subtotal:0,
    pdfLine:0,
    d_pdf:false,
    pdfUrl:null,

}),
  async mounted(){
    this.loading=true;
    this.user=localStorage.getItem('dops_myuser');
    this.apikey=localStorage.getItem('dops_apiKey');
    this.contrato=localStorage.getItem('dops_mycontrato');
    this.bloqueo = await this.myPermiso(8);
    if(parseInt(this.bloqueo)!=0){
        this.loading=true;
        await this.searchEmisor()
        await this.searchOrden()
        await this. searchProveedor()
        this.loading=false;
    }
    this.loading=false;
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    async editar_proveedor(){
        // this.id_proveedor=0;
        // this.rut='';
        // this.razon='';
        // this.giro='';
        // this.contacto='';
        // this.telefono='';
        // this.email='';
        // this.direccion='';
        // this.comuna_ciudad='';
        this.btn_proveedor=true;
    },
    async lista_proveedor(){
        this.id_proveedor=0;
        this.rut='';
        this.razon='';
        this.giro='';
        this.contacto='';
        this.telefono='';
        this.email='';
        this.direccion='';
        this.comuna_ciudad='';
        this.btn_proveedor=false;
        this.d_proveedor=true
    },
    async clsInput(){
        this.fecha_orden=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        this.orden='';
        this.id_proveedor=0;
        this.rut='';
        this.razon='';
        this.giro='';
        this.contacto='';
        this.telefono='';
        this.email='';
        this.direccion='';
        this.comuna_ciudad='';
        this.autorizado='';
        this.transporte='';
        this.atencion='';
        this.fecha_entrega=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        this.codigo='';
        this.descripcion='';
        this.precio='';
        this.cantidad='';
        this.items=[];
        this.forma='Contado';
        this.observa='';
        this.btn_grabar=false;
        this.btn_editar=false;
        this.btn_proveedor=false;
        this.descuento=0;
        this.subtotal=0;
        this.pdfLine=0;
    },
    async searchEmisor(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/emisor/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.emisor = datos
            };
        } catch (error) {
            console.log(error)
        }
    },
    async searchOrden(){
        this.orden_lista=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                orden: 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/order/buys/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.orden_lista = datos
            };
        } catch (error) {
            console.log(error)
        }
    },
    async searchProveedor(){
        this.proveedor_lista=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                rut: 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/proveedor/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.proveedor_lista = datos
            };
        } catch (error) {
            console.log(error)
        }
    },
    async handleOrdenes(line){
        this.fecha_orden=line.fecha;
        this.orden=line.orden;
        this.rut=line.rut;
        this.razon=line.razon;
        //buscar datos de la lista de proveedores
        const data_proveedor = this.proveedor_lista.filter(res => res.rut == line.rut);
        if(data_proveedor.length!=0){
            this.giro=data_proveedor[0].giro;
            this.contacto=data_proveedor[0].contacto;
            this.telefono=data_proveedor[0].telefono;
            this.email=data_proveedor[0].email;
            this.direccion=data_proveedor[0].direccion;
            this.comuna_ciudad=data_proveedor[0].comuna_ciudad;
        };
        this.autorizado=line.autorizado;
        this.transporte=line.transporte;
        this.atencion=line.atencion;
        this.fecha_entrega=line.entrega;
        this.forma=line.forma_pago;
        this.observa=line.observa;
        await this.searchDetalleOC();
        this.btn_editar=true;
        this.d_orden=false;
    },
    async searchDetalleOC(){
        if(this.orden!=''){
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    orden: this.orden
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/detail/buys/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    let index = 0;
                    datos.forEach(element => {
                        index = index + 1;
                        const total_line = parseFloat(parseFloat(element.precio)*parseFloat(element.cantidad)).toFixed(0);
                        this.items.push({
                            id: index,
                            codigo: element.codigo,
                            descripcion: element.descripcion,
                            precio: element.precio,
                            cantidad: element.cantidad,
                            total: total_line
                        })                       
                    })
                }
            } catch (error) {
                console.log(error)
            }
        }
    },
    async handleProveedores(line){
        this.rut=line.rut;
        this.razon=line.razon;
        this.giro=line.giro;
        this.contacto=line.contacto;
        this.telefono=line.telefono;
        this.email=line.email;
        this.direccion=line.direccion;
        this.comuna_ciudad=line.comuna_ciudad;
        this.d_proveedor=false
    },
    async add_item(){
        this.loading=true;
        if(this.codigo!='' && this.descripcion!='' && this.precio!='' && this.cantidad!=''){
            if(this.codigo!=null && this.descripcion!=null && this.precio!=null && this.cantidad!=null){
                //iniciamos el numero de item
                let temp_items = [];
                let index = 0;
                this.items.forEach(element => {
                    index = index + 1
                    temp_items.push({
                        id: index,
                        codigo: element.codigo,
                        descripcion: element.descripcion,
                        precio: element.precio,
                        cantidad: element.cantidad,
                        total: element.total
                    })
                });
                //agregamos el item nuevo
                index = index + 1;
                const nTotal = parseFloat(parseFloat(this.precio) * parseFloat(this.cantidad)).toFixed(0);
                temp_items.push({
                    id: index,
                    codigo: this.codigo,
                    descripcion: this.descripcion,
                    precio: this.precio,
                    cantidad: this.cantidad,
                    total: nTotal
                });
                this.items = temp_items;
                this.codigo='';
                this.descripcion='';
                this.precio='';
                this.cantidad='';
            } else {
                this.mensaje='Datos del item son obligatorios';
                this.color_snack='red';
                this.snack=true;
            }
        } else {
            this.mensaje='Datos del item son obligatorios';
            this.color_snack='red';
            this.snack=true;
        }
        this.loading=false;
    },
    async delete_item(line){
        this.loading=true;
        let temp_items = this.items;
        temp_items = temp_items.filter(function(dat) {
            return dat.id !== line.id; 
        });
        //reindexar los id de Items
        this.items=[];
        let index = 0;
        temp_items.forEach(element => {
            index = index + 1
            this.items.push({
                id: index,
                codigo: element.codigo,
                descripcion: element.descripcion,
                precio: element.precio,
                cantidad: element.cantidad,
                total: element.total
            })
        });
        this.loading=false;
    },
    async save_orden(){
        this.loading=true;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            //grabar al proveedor por si no existe
            const filter = this.proveedor_lista.filter(res => res.rut == this.rut);
            if(filter.length!=0){
                await this.update_proveedor()
            } else {
                await this.save_proveedor()
            };
            //obtener numero de orden automatico
            const timestamp = Date.now();
            const params = {
                contrato : this.contrato,
                user :  this.user,
                clave: timestamp
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/oc/number/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.orden=datos[0].id;
                //grabamos los datos de la orden
                const params1 = {
                    contrato : this.contrato,
                    user :  this.user,
                    fecha: this.fecha_orden,
                    orden: this.orden,
                    rut: this.rut,
                    autorizado: this.autorizado,
                    transporte: this.transporte,
                    atencion: this.atencion,
                    entrega: this.fecha_entrega,
                    forma_pago: this.forma,
                    observa: this.observa,
                    estado:'V'
                };
                const res1 = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/buys/',params1,{headers});
                const datos1 = res1.data;
                if(datos1[0].existe=='si'){
                    //grabamos el detalle de la orden
                    for (let index = 0; index < this.items.length; index++) {
                        const element = this.items[index];
                        const params2 = {
                            contrato : this.contrato,
                            user :  this.user,
                            orden: this.orden,
                            codigo: element.codigo,
                            descripcion: element.descripcion,
                            precio: element.precio,
                            cantidad: element.cantidad
                        };
                        const res2 = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/detail/buys/',params2,{headers});
                        const datos2 = res2.data;
                        if(datos2[0].existe=='si'){
                            this.btn_grabar=true;
                            this.mensaje='Orden de Compra grabada';
                            this.color_snack='success';
                            this.snack=true;
                            await this.searchProveedor();
                            await this.searchOrden();
                        }
                    }
                }
            };            
        } catch (error) {
            console.log(error)
        }
        this.loading=false;
    },
    async update_orden(){
        this.loading=true;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            //grabar al proveedor por si no existe
            const filter = this.proveedor_lista.filter(res => res.rut == this.rut);
            if(filter.length!=0){
                await this.update_proveedor()
            } else {
                await this.save_proveedor()
            };
            //update de la orden
            const params = {
                contrato : this.contrato,
                user :  this.user,
                fecha: this.fecha_orden,
                orden: this.orden,
                rut: this.rut,
                autorizado: this.autorizado,
                transporte: this.transporte,
                atencion: this.atencion,
                entrega: this.fecha_entrega,
                forma_pago: this.forma,
                observa: this.observa,
                estado: 'V',
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/buys/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                //eliminamos el detalle de la orden
                const params1 = {
                    contrato : this.contrato,
                    user :  this.user,
                    orden: this.orden,
                };
                const res1 = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/detail/buys/',params1,{headers});
                const datos1 = res1.data;
                if(datos1[0].existe=='si'){
                    //grabamos el detalle de la orden
                    for (let index = 0; index < this.items.length; index++) {
                        const element = this.items[index];
                        const params2 = {
                            contrato : this.contrato,
                            user :  this.user,
                            orden: this.orden,
                            codigo: element.codigo,
                            descripcion: element.descripcion,
                            precio: element.precio,
                            cantidad: element.cantidad
                        };
                        const res2 = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/detail/buys/',params2,{headers});
                        const datos2 = res2.data;
                        if(datos2[0].existe=='si'){
                            this.btn_grabar=true;
                            this.mensaje='Orden de Compra modificada';
                            this.color_snack='success';
                            this.snack=true;
                            await this.searchProveedor();
                            await this.searchOrden();
                        }
                    }
                }
            }
        } catch (error) {
            console.log(error)
        }
        this.loading=false;    
    },
    async save_proveedor(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                rut: this.rut,
                razon: this.razon,
                giro: this.giro,
                direccion: this.direccion,
                comuna_ciudad: this.comuna_ciudad,
                contacto: this.contacto,
                telefono: this.telefono,
                email: this.email,
                estado:'V'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/proveedor/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                console.log('save proveedor ok')
            }
        } catch (error) {
            console.log(error)
        }
    },
    async update_proveedor(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                rut: this.rut,
                razon: this.razon,
                giro: this.giro,
                direccion: this.direccion,
                comuna_ciudad: this.comuna_ciudad,
                contacto: this.contacto,
                telefono: this.telefono,
                email: this.email,
                estado:'V'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/proveedor/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                console.log('update proveedor ok')
            }
        } catch (error) {
            console.log(error)
        }
    },
    async print_orden(){
        if(this.orden!=''){
            if(this.items.length!=0){
                this.loading=true;
                //formateamos a 6 hojas
                this.pdfLine = 0;
                this.subtotal = 0;
                const datos = this.items;
                let hojas_array = [];
                const hoja0 = datos.slice(0, 25)
                hojas_array.push(hoja0);
                const hoja1 = datos.slice(25, 50)
                hojas_array.push(hoja1);
                const hoja2 = datos.slice(50, 75)
                hojas_array.push(hoja2);
                const hoja3 = datos.slice(75, 100)
                hojas_array.push(hoja3);
                const hoja4 = datos.slice(100, 125)
                hojas_array.push(hoja4);
                const hoja5 = datos.slice(125, 150)
                hojas_array.push(hoja5);
                const hoja6 = datos.slice(150, 200)
                //juntamos las hojas en un array
                let numero_hoja = 0;
                let doc = new jsPDF('p', 'mm', 'letter');
                for (let index = 0; index < hojas_array.length; index++) {
                const detail = hojas_array[index];
                if(detail.length!=0){
                    numero_hoja = numero_hoja + 1;
                    if(parseInt(numero_hoja) != 1) {
                    doc.addPage('p','mm','letter');
                    } 
                    await this.orden_PDF(doc,detail);
                }
                };
                //doc.output('dataurlnewwindow')
                const basePDF = doc.output('datauristring');
                const posicion = basePDF.indexOf("base64,");
                const pdf_base64 = basePDF.substring((posicion + 7));
                this.d_pdf=true;
                await this.mostrarPDF(pdf_base64);
                this.loading=false
            } else {
                this.mensaje='No existen datos en la lista';
                this.color_snack='error';
                this.snack=true;
            }
        } else {
            this.mensaje='Ingrese nuemro de orden';
            this.color_snack='error';
            this.snack=true;
        }
    },
    async orden_PDF(doc,datos){
        var img = document.getElementById("logo");
        doc.addImage(img,'JPEG',2,5,70,20);
        //doc.text('LOGO', 5, 10);
        doc.setFont("arial", "bold");
        doc.setFontSize(14);
        doc.text('ORDEN DE COMPRA', 175, 12, { align: "center" });
        doc.text('N°  ' + this.orden, 175, 20, { align: "center" });      

        //new Intl.NumberFormat('de-DE').format(this.total_carga) 

        doc.setFont("arial", "normal");
        doc.setFontSize(8);
        
        doc.line(3, 30, 209, 30);
        //doc.text('RUT:', 5, 34);
        doc.text('RAZON SOCIAL:', 5, 38);
        doc.text('DIRECCION:', 5, 42);
        doc.text('COMUNA - CIUDAD:', 5, 46);
        doc.text('CONTACTO:', 5, 50);
        doc.text('TELEFONO:', 75, 50);
        doc.text('EMAIL:', 5, 54);
        doc.text('' + this.razon, 34, 38);
        doc.text('' + this.direccion, 34, 42);
        doc.text('' + this.comuna_ciudad, 34, 46);
        doc.text('' + this.contacto, 34, 50);
        doc.text('' + this. telefono, 92, 50);
        doc.text('' + this.email, 34, 54);

        doc.text('AUTORIZADO POR:', 125, 38);
        doc.text('TRANSPORTE:', 125, 42);
        doc.text('ATENCION DE:', 125, 46);
        doc.text('FECHA ENTREGA:', 125, 50);

        doc.text('' + this.autorizado, 152, 38);
        doc.text('' + this.transporte, 152, 42);
        doc.text('' + this.atencion, 152, 46);
        doc.text('' + this.fecha_entrega, 152, 50);

        doc.text('OBSERVACIÓN: ' + this.observa, 5, 60);

        doc.line(3, 64, 209, 64);
        doc.text('ITEM', 5, 68);
        doc.text('CODIGO', 20, 68);
        doc.text('DESCRIPCION', 45, 68);
        doc.text('PRECIO', 140, 68);
        doc.text('CANTIDAD', 168, 68);
        doc.text('TOTAL', 191, 68);
        doc.line(3, 70, 209, 70);

        //imprimir productos refundidos
        let line = 70;
        datos.forEach(element => {
            line = line + 5;
            this.pdfLine = parseFloat(this.pdfLine) + 1;
            doc.text('' + this.pdfLine, 7, line, { align: "center" })
            doc.text(element.codigo.toString(), 20, line);
            doc.text(element.descripcion.toString(), 45, line);
            doc.text(''+ new Intl.NumberFormat('de-DE').format(element.precio), 150, line, { align: "right" });
            doc.text(''+ new Intl.NumberFormat('de-DE').format(element.cantidad), 175, line, { align: "center" });
            doc.text(''+ new Intl.NumberFormat('de-DE').format(element.total), 200, line, { align: "right" });
            this.subtotal = parseFloat(this.subtotal) + parseFloat(element.total);                
        });
        doc.line(3, 205, 209, 205);
        if(parseFloat(this.pdfLine)==this.items.length){
            doc.text('SUBTOTAL:', 155, 210);
            doc.text('DESCUENTO:', 155, 215);
            doc.text('NETO:', 155, 220);
            doc.text('IVA (19%):', 155, 225);
            doc.text('TOTAL:', 155, 230);

            doc.setFont("arial", "bold");
            doc.setFontSize(9);
            doc.text(''+ new Intl.NumberFormat('de-DE').format(this.subtotal), 200, 210, { align: "right" });
            doc.text(''+ new Intl.NumberFormat('de-DE').format(this.descuento), 200, 215, { align: "right" });
            const neto = parseFloat(this.subtotal) - parseFloat(this.descuento);
            doc.text(''+ new Intl.NumberFormat('de-DE').format(neto), 200, 220, { align: "right" });
            const iva = parseFloat((parseFloat(neto)*19)/100).toFixed(0);
            const total_documento = parseFloat(neto) + parseFloat(iva);
            doc.text(''+ new Intl.NumberFormat('de-DE').format(iva), 200, 225, { align: "right" });
            doc.text(''+ new Intl.NumberFormat('de-DE').format(total_documento), 200, 230, { align: "right" });
            doc.setFont("arial", "normal");
            doc.setFontSize(8);

            doc.line(3, 233, 209, 233);
            doc.text('FORMA DE PAGO : ' + this.forma.toUpperCase(), 5, 237);
            doc.text('' + this.fecha_orden, 100, 237);
            doc.line(3, 239, 209, 239);
            doc.text('FACTURAR A:', 5, 244);
            if(this.emisor.length!=0){
                doc.text('' + this.emisor[0].razon, 5, 250);
                doc.text('RUT: ' + this.emisor[0].rut, 5, 254);
                doc.text('GIRO: ' + this.emisor[0].giro, 5, 258);
                doc.text('DIRECCION: ' + this.emisor[0].direccion + ' ' + this.emisor[0].comuna + ' ' + this.emisor[0].ciudad, 5, 262);
            } else {
                doc.text('DOSP S.A.', 5, 250);
                doc.text('RUT: 76.011.319-0', 5, 254);
                doc.text('GIRO: Ingeniería', 5, 258);
                doc.text('DIRECCIÓN: Carnot 801 San Miguel Santiago', 5, 262);
            }

            doc.text('FIRMA AUTORIZADO', 155, 262);

            doc.setFont("arial", "bold");
            doc.setFontSize(9);
            doc.text('El número de la orden de compra debe aparecer en todas las facturas y correspondencia.', 100, 272, { align: "center" });
        }
    },
    async mostrarPDF(base64String) {
        if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);
        const bytes = atob(base64String);
        const arr = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
            arr[i] = bytes.charCodeAt(i);
        }
        const blob = new Blob([arr], { type: 'application/pdf' });
        this.pdfUrl = URL.createObjectURL(blob);
    },
    async beforeDestroy() {
        if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);
    },
    async close_pdf(){
        this.d_pdf=false;
        await this.beforeDestroy()
    },

  }
}
</script>
